import * as helpers from '../helpers';

const addValue = (arr, value) => {
    if (arr.indexOf(value) === -1) {
        arr.push(value);
    }
};

const removeValue = (arr, value) => {
    let index = arr.indexOf(value);
    while (index !== -1) {
        arr.splice(index, 1);
        index = arr.indexOf(value);
    }
};

const getCategoryLength = checkbox => checkbox.parentElement.querySelectorAll('input[type="checkbox"]').length;
const getSubcategories = checkbox => [].slice.call(checkbox.parentElement.lastElementChild.querySelectorAll('input[type="checkbox"]'));
const getParentCat = (checkbox) => {
    const group = helpers.findAncestor(checkbox, 'checkbox-group');

    if (group !== null) {
        return group.querySelector('input[type="checkbox"]');
    }

    return group;
};

const getCheckedItems = (items) => {
    let checkedItems = 1;

    items.forEach((item) => {
        checkedItems = item.checked ? checkedItems + 1 : checkedItems;
    });

    return checkedItems;
};

const checkParent = (checkbox, arr) => {
    const parentCategory = getParentCat(checkbox);

    if (parentCategory === null) {
        return;
    }

    const categoryLength = getCategoryLength(parentCategory);
    const checkedItems = getCheckedItems(getSubcategories(parentCategory));

    parentCategory.checked = checkedItems === categoryLength;

    if (parentCategory.checked) {
        addValue(arr, parentCategory.value);
    } else {
        removeValue(arr, parentCategory.value);
    }

    checkParent(parentCategory.parentElement.parentElement, arr);
};

const handleCategories = (checkbox, arr) => {
    if (checkbox.checked) {
        addValue(arr, checkbox.value);

        if (getSubcategories(checkbox).length) {
            getSubcategories(checkbox).forEach((subcategory) => {
                subcategory.checked = true;
                addValue(arr, subcategory.value);
            });
        }
    } else {
        removeValue(arr, checkbox.value);

        if (getSubcategories(checkbox).length) {
            getSubcategories(checkbox).forEach((subcategory) => {
                subcategory.checked = false;
                removeValue(arr, subcategory.value);
            });
        }
    }

    checkParent(checkbox, arr);
};

export default function initMulticategoies() {
    const output = document.querySelector('.js-get-categories');
    const input = [].slice.call(document.querySelectorAll('.js-set-categories'));

    if (output === null || input === null) {
        return;
    }

    const values = [];
    input.forEach((categorySet) => {
        const checkboxes = [].slice.call(categorySet.querySelectorAll('input[type="checkbox"]'));

        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('click', () => {
                handleCategories(checkbox, values);
                console.log(values);
                output.value = values.join(',');
            });
        });
    });
}
